import I18n from 'i18n-js';
import da from './da.json';
import en from './en.json';

I18n.fallbacks = true;
I18n.translations = { da, en };

export function txt(scope: I18n.Scope, options?: I18n.TranslateOptions | undefined): string {
	// set ant design locales!
	i18n.locale = localStorage.getItem('bb_locale') ?? 'da';
	return I18n.t(scope, options);
}

export const i18n = I18n;
